export default __webpack_public_path__ + "static/media/Forceful Pirate Ring.357a4d3a.jpg";